import { render, staticRenderFns } from "./AddressPerson.vue?vue&type=template&id=c460655e"
import script from "./AddressPerson.vue?vue&type=script&lang=js"
export * from "./AddressPerson.vue?vue&type=script&lang=js"
import style0 from "./AddressPerson.vue?vue&type=style&index=0&id=c460655e&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports